<template>
    <div v-if="!!code" class="w-root">
        <div class="w-views">
            <div class="secondary-menu go-pro">

                <div class="secondary-menu-header">
                    <i class="back" @click="goTo('/discover')"></i>
                </div>

                <vue-custom-scrollbar ref="vueCustomScrollbar" class="secondary-menu-body">
                    <ProfileSubscriptionUpgradeView :code="code" />
                </vue-custom-scrollbar>
                
                <BottomBar v-if="isMobile" tab="profile"/>
            </div>
        </div><!--w-views-->
    </div><!--w-root-->
</template>

<script>
    import BottomBar from '@buddy/views/widgets/BottomBar.vue';
    import ProfileSubscriptionUpgradeView from '@profile/views/widgets/subscription/ProfileSubscriptionUpgradeView.vue';

    // custom scrollbar
    import vueCustomScrollbar from 'vue-custom-scrollbar'
    import "vue-custom-scrollbar/dist/vueScrollbar.css"

    export default {
        mixins: [
            require('@general/lib/mixin').default
        ],
        data() {
            return {
                code: '',
            }
        },
        components: {
            BottomBar,
            ProfileSubscriptionUpgradeView,
            vueCustomScrollbar,
        },
        methods: {
            
        },
        created() {
            this.code = this.$route.query.code;
        }
    }
</script>
